/** @jsx jsx */
import { jsx } from "@emotion/react";
import { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { FavouriteTemplatesModal } from "../../../../molecules/modals/TemplateLinkCardListModals";
import {
  Module,
  ModuleIcon,
  ModuleName,
} from "../Modules/components/ModuleDropdown/styles";

export type FavouriteTemplatesProps = {
  isOpen: boolean;
  toggleOpen: () => void;
};

const FavouriteTemplates = ({
  isOpen,
  toggleOpen,
}: FavouriteTemplatesProps) => (
  <Fragment>
    <Module onClick={toggleOpen} isToggled={isOpen}>
      <ModuleIcon>star_border</ModuleIcon>
      <ModuleName>
        <FormattedMessage id="common.favourite" />
      </ModuleName>
    </Module>

    <FavouriteTemplatesModal isOpen={isOpen} toggleOpen={toggleOpen} />
  </Fragment>
);

export default FavouriteTemplates;
